import React from "react";
import {
  Box, Button, Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogTitle, List, ListItem, ListItemText, Stack, Tooltip, Typography,
} from "@mui/material";
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';

export default function ViewDialog({
  open,
  viewTargetRow,
  viewSelection,
  onToggleSelection,
  onClose,
  onExcludeSelected,
  onIncludeSelected,
  getActiveGbifRecords,
  getGbifDisplayName,
  GBIF_BACKBONE_DATASET_KEY,
}) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>マージ内容の確認 / 編集</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          {viewTargetRow?.db_record && (
            <Box sx={{ p: 1.5, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
              <Typography variant="subtitle2" gutterBottom>DB レコード</Typography>
              <Typography variant="body2">Name: {viewTargetRow.db_record.name}</Typography>
              <Typography variant="body2">Author: {viewTargetRow.db_record.author || 'N/A'}</Typography>
              <Typography variant="body2">Year: {viewTargetRow.db_record.year || 'N/A'}</Typography>
              <Typography variant="body2">Parent: {viewTargetRow.db_record.parent_name} (ID: {viewTargetRow.db_record.parent_id})</Typography>
            </Box>
          )}

          <Box>
            <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
              <Typography variant="subtitle2">GBIF レコード</Typography>
              <Chip size="small" label={`マージ対象: ${getActiveGbifRecords(viewTargetRow || {}).length}`} color="success" />
            </Stack>
            <List dense sx={{ maxHeight: 360, overflow: 'auto' }}>
              {(viewTargetRow?.gbif_records || []).map((g) => {
                const key = String(g.key);
                const checked = viewSelection.includes(key);
                const isBackbone = g.datasetKey === GBIF_BACKBONE_DATASET_KEY;
                return (
                  <ListItem
                    key={key}
                    divider
                    alignItems="flex-start"
                    secondaryAction={
                      <Checkbox
                        edge="end"
                        checked={checked}
                        onChange={() => onToggleSelection?.(key)}
                      />
                    }
                  >
                    <ListItemText
                      primary={
                        <Stack direction="row" spacing={1} alignItems="center">
                          {isBackbone && (
                            <Tooltip title="GBIF Backbone">
                              <VerifiedUserIcon fontSize="inherit" sx={{ color: 'success.light' }} />
                            </Tooltip>
                          )}
                          <Typography variant="body2">{getGbifDisplayName(g)}</Typography>
                          <Chip size="small" label={g.taxonomicStatus || 'N/A'} />
                          {g.excluded && <Chip size="small" color="warning" label="除外中" />}
                        </Stack>
                      }
                      secondary={
                        <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'normal' }}>
                          Key: {key} / Author: {g.authorship || 'N/A'} / Year: {g.publishedInYear || 'N/A'} / Parent: {g.parent || 'N/A'} / ParentKey: {g.parentKey || 'N/A'}
                        </Typography>
                      }
                    />
                  </ListItem>
                );
              })}
              {(viewTargetRow?.gbif_records || []).length === 0 && (
                <ListItem>
                  <ListItemText primary="GBIFレコードがありません" />
                </ListItem>
              )}
            </List>
          </Box>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onExcludeSelected} disabled={!viewSelection.length}>選択をマージから除外</Button>
        <Button onClick={onIncludeSelected} disabled={!viewSelection.length}>選択をマージ対象に戻す</Button>
        <Button onClick={onClose}>閉じる</Button>
      </DialogActions>
    </Dialog>
  );
}
